var map = {
	"./pic1.jpg": 175,
	"./pic2.jpg": 176,
	"./pic3.jpg": 177,
	"./pic4.jpg": 178,
	"./pic5.jpg": 179,
	"./pic6.jpg": 180,
	"./pic7.jpg": 181,
	"./pic8.jpg": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;